query oddsCheckerSuperAdminEvents(
  $first: Int,
  $offset: Int,
  $condition: EventCondition,
  $filter: EventFilter,
  $superAdminMarketsCondition: SuperAdminMarketCondition,
  $superAdminMarketsFilter: SuperAdminMarketFilter
) {
  allEvents(
    first: $first
    offset: $offset
    orderBy: STARTS_AT_ASC
    condition: $condition
    filter: $filter
  ) {
    events: nodes {
      eventId
      eventName
      matchState
      sportId
      competitionId
      startsAt
      isUsaView
      competitors
      limbo
      eventReadiness: eventReadinessByEventId {
        isApproved
      }
      sport {
        sportId
        sportName
        sportLabel
      }
      markets: superAdminMarketsByEventId(
        condition: $superAdminMarketsCondition,
        filter: $superAdminMarketsFilter,
      ) {
        nodes {
          source
          marketCode
          selections
          marketSummary
          marketType
          offeringStatus
          marketId
          inPlay
          displayStatus
          operatorId
        }
      }
    }
    totalCount
  }
}
